// extracted by mini-css-extract-plugin
export default {"message_area":"social-suggested-followees-SuggestedFacebookMembers__message_area--2pjOW","refetch":"social-suggested-followees-SuggestedFacebookMembers__refetch--2sGB2"};